export const neurological = (() => {
    const placeHolderText = 'No Headache, difficulty with speech, swallowing, facial asymmetry, weakness or numbness.  '

    return placeHolderText
})